/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-07 15:55:06
 * @LastEditors: K
 * @LastEditTime: 2022-09-19 17:41:23
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { Col } from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { EditableList } from '../../compnents/list/EditableList'
import { TenantQueryParams } from '../../services/tenant'
import { ThemeContext } from '../../theme/ThemeContext'
import { supplierColumns } from './ReplaceMakeSupplierColumns'
import styles from './ReplaceMakeSupplier.module.css'
import {
  getPotionPlaceAsync,
} from './ReplaceMakeSupplierSclice'
interface SupplierProps {
  state: string
}
// 代煎供应商
export const Supplier = ({ state }: SupplierProps): ReactElement => {
  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const [data, setData] = useState<any>()

  const [total, setTotal] = useState<any>()

  const [params, setParams] = useState<TenantQueryParams>({
    size: 10,
    // current: location?.state?.current || 1,
    current: 1,
  })

  useEffect(() => {
    dispatch(
      getPotionPlaceAsync()
    )
      .then(unwrapResult)
      .then((res: any) => {
        setData(res)
      })
  }, [])

  useEffect(() => {
    sessionStorage.setItem(location.pathname, JSON.stringify({ state }))
  }, [state])

  return (
    <Col className={styles.wrap}>
      <Col className={styles.contentWrap}>
        <EditableList
          page={{
            items: data,
            current: params.current || 1,
            size: params.size || 10,
            total,
          }}
          style={{ color: theme.tc3 }}
          className={styles.table}
          columns={supplierColumns()}
          pagination={false}
        />
      </Col>
    </Col>
  )
}
